import { ExpandableText } from "@volca/ui/components/ui/expandable-text";
import { Stack } from "@volca/ui/components/ui/stack";
import { ActionRowGlyph, ActionRowHeader } from "@/accounts-payable/common";
import type { ApAgentAction } from "@/accounts-payable/types";
import { actionDetail, isPendingReviewAction } from "@/accounts-payable/utils";

/**
 * One agent action as a checklist row — the same shape pending or resolved:
 * status glyph, a title in primary, the target in secondary (the header is
 * shared with the review page). Pending rows add the confidence and the
 * agent's reasoning; resolved rows stay quiet and only speak up with who
 * decided or when something went off-plan. Approving happens on the review
 * page.
 */
export const ActionChecklistRow = ({ action }: { action: ApAgentAction }) => {
  const pending = isPendingReviewAction(action);

  return (
    <Stack direction="row" gap={2} align="start" className="w-full py-3">
      <ActionRowGlyph action={action} />
      <Stack align="start" gap={2} className="min-w-0 flex-1">
        <ActionRowHeader action={action} showTarget />
        {/* The reasoning supports a proposal still to decide, so it's the
            quietest line and clamps to two; the review page has all of it. */}
        {pending &&
          action.rationale &&
          action.rationale !== actionDetail(action) && (
            <ExpandableText text={action.rationale} maxLines={2} tone="muted" />
          )}
      </Stack>
    </Stack>
  );
};
